module.exports = __webpack_public_path__ + "img/car-lot.cd5be7d8.jpg";